import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './ShopCirclesIntroBanner.scss';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';

import { getFeaturedGroups, getNumRecentFindsForGroupId } from '../../Helpers/shop_helpers';
import { getCuratorGroups, getCuratorGroupsWithUsers, getCuratorGroupFavorites } from '../../Helpers/user_helpers';
import { syncFeaturedCuratorGroups } from '../../Actions/ShopActions';
import { openNewCircleModal } from '../../Actions/UIActions';

import CuratorGroupCard from '../Curators/CuratorGroupCard';

const ShopCirclesIntroBanner = props => {
  const { shop, user } = props;
  const featuredGroups = getFeaturedGroups(shop);
  const curatorGroups = getCuratorGroups(user);
  const curatorGroupsWithUsers = getCuratorGroupsWithUsers(user);
  const favorites = getCuratorGroupFavorites(user);
  const hasLoadedFeaturedGroups = featuredGroups.length > 0;

  const clickToCreateNewCircle = () => {
    props.openNewCircleModal({
      params: {},
      closeCallback: () => {},
      submitCallback: () => {}
    });
  };

  React.useEffect(() => {
    props.syncFeaturedCuratorGroups();
  }, []);

  // Additional UI
  const additionalClasses = {
    'has-curator-groups': curatorGroupsWithUsers.length > 0
  };

  // Determine visibility
  const isFeaturedGroupSelected = props.CuratorGroup_id && featuredGroups.some(group => group.id === props.CuratorGroup_id);
  const isVisible = props.isUnfilteredState || isFeaturedGroupSelected;
  if (!isVisible) return null;

  return (
    <div className={cn('shop-circles-intro-banner-outer-container', additionalClasses)}>
      <div className={cn('shop-circles-intro-banner-inner-container', additionalClasses)}>
        <div className={cn('all-circles-container', additionalClasses)}>
          {curatorGroupsWithUsers.length > 0 && (
            <div className='featured-circles-container'>
              <Link to='/shop/my/circles' className='featured-circles-title'>
                Shop Your Circles
              </Link>
              <div className='featured-circles'>
                {curatorGroupsWithUsers.map(group => {
                  return (
                    <div key={group.id} className='featured-circle'>
                      <CuratorGroupCard
                        user={user}
                        isSelected={props.CuratorGroup_id === group.id}
                        isAnotherSelected={props.CuratorGroup_id && props.CuratorGroup_id !== group.id}
                        group={group}
                        numNewToShow={getNumRecentFindsForGroupId(shop, group.id)}
                        isStretch
                        canCloseGoBackToRootShop
                        hideActions
                        openToTab='latest'
                        eventClickSourceData={{
                          source: 'Shop Circles Intro Banner'
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div className={cn('create-circle-container', additionalClasses)}>
            <div onClick={clickToCreateNewCircle} className='create-circle-button'>
              <div className='content'>
                {curatorGroups.length > 0 ? (
                  <div className='main'>
                    Create another
                    <br />
                    circle
                  </div>
                ) : (
                  <div className='main'>
                    Create your
                    <br />
                    first circle
                  </div>
                )}
                <div className='secondary'>Add curators you trust and unlock a shop made just for you.</div>
              </div>
              <div className='create-circle-button-container'>
                <div className='create-circle-button-icon'>
                  <FontAwesomeIcon icon={faPlus} />
                </div>
              </div>
            </div>
          </div>
          {!!favorites.length && (
            <div className='featured-circles-container'>
              <Link to='/shop/my/circles' className='featured-circles-title'>
                Your Favorited Circles
              </Link>
              <div className='featured-circles'>
                {favorites.map(({ curator_group }) => {
                  return (
                    <div key={curator_group.id} className='featured-circle'>
                      <CuratorGroupCard
                        user={user}
                        isSelected={props.CuratorGroup_id === curator_group.id}
                        isAnotherSelected={props.CuratorGroup_id && props.CuratorGroup_id !== curator_group.id}
                        group={curator_group}
                        numNewToShow={getNumRecentFindsForGroupId(shop, curator_group.id)}
                        isStretch
                        canCloseGoBackToRootShop
                        hideActions
                        openToTab='popular'
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div className='featured-circles-container'>
            <Link to='/shop/circles' className='featured-circles-title'>
              Explore Popular Circles
            </Link>
            <div className='featured-circles'>
              {hasLoadedFeaturedGroups
                ? featuredGroups.map(group => {
                    return (
                      <div key={group.id} className='featured-circle'>
                        <CuratorGroupCard
                          user={user}
                          isSelected={props.CuratorGroup_id === group.id}
                          isAnotherSelected={props.CuratorGroup_id && props.CuratorGroup_id !== group.id}
                          group={group}
                          isStretch
                          canCloseGoBackToRootShop
                          hideActions
                          openToTab='popular'
                        />
                      </div>
                    );
                  })
                : _.range(5).map(idx => <div className='featured-circle loading' key={idx} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ShopCirclesIntroBanner.propTypes = {
  // From Inside
  user: PropTypes.object.isRequired,
  shop: PropTypes.object.isRequired,
  syncFeaturedCuratorGroups: PropTypes.func.isRequired,
  openNewCircleModal: PropTypes.func.isRequired,

  // From Outside
  isCuratedShop: PropTypes.bool.isRequired,
  isUnfilteredState: PropTypes.bool.isRequired,
  CuratorGroup_id: PropTypes.number
};

const mapStateToProps = state => {
  const { user, shop } = state;
  return { user, shop };
};

export default connect(mapStateToProps, {
  openNewCircleModal,
  syncFeaturedCuratorGroups
})(withRouter(ShopCirclesIntroBanner));
